import React from "react";
import "./style/SearchButton.css";

function SearchButton() {
  return <button className="btn btn-primary">Search</button>;
}

export default SearchButton;
